import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';
import { getProcedimentosDropdown } from '../../Libs/filaProcedimentos';

var timer;

export default class DropDownProcedimentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      procedimentos: [],
      procedimentosShow: [],
      procedimentoSelecionado: this.props.procedimentoSelecionado,
      cacheItems: []
    };
    this.promiseOptions = this.promiseOptions.bind(this);
  }

  async componentDidUpdate() {
    if (this.props.updateDropDown && this.props.updateDropDown === true) {
      if (this.props.setUpdateDropDown) {
        this.props.setUpdateDropDown(false)
      }

    }
  }

  async promiseOptions(inputValue) {

    return new Promise((resolve) => {
      clearTimeout(timer);

      timer = setTimeout(async () => {
        if (inputValue !== "") {
          let pacs = await getProcedimentosDropdown(inputValue)

          let items = pacs.map(
            (res, i) => {
              return {
                value: res,
                label: `${res.codigo} - ${res.descricao}`,
              }
            }
          )
          this.setState({ cacheItems: items })
          resolve(items)
        }
      }, 1000);
    });
  }


  render() {
    return (
      <div className="container">
        <AsyncSelect
          value={this.state.procedimentoSelecionado}
          // onInputChange={e => this.filtrar(e)}
          placeholder="Busque por Nome ou Código"
          isClearable
          defaultOptions={this.state.cacheItems}
          loadOptions={this.promiseOptions}
          noOptionsMessage={() => "Nenhum resultado encontrado"}
          onChange={v => {
            this.setState({
              procedimentoSelecionado: v
            })
            this.props.change(v)
          }} />
      </div>
    );
  }
}